import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import { AditamentoApiResponse } from 'store/modules/apis/aditamento';

export const GETAditamentoList = async (
  dispatch: Dispatch,
  pagination: { page: number; pageSize: number },
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<AditamentoApiResponse>(`${requestConfig.api}api/v1/aditamentos/paginated`, {
        params: { page: pagination.page, pageSize: pagination.pageSize },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETAditamentoById = async (
  dispatch: Dispatch,
  instrumentoFinanceiroId: string,
  pagination: { page: number; pageSize: number },
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<AditamentoApiResponse>(`${requestConfig.api}api/v1/aditamentos/paginated`, {
        params: {
          instrumentoFinanceiroIds: [instrumentoFinanceiroId],
          page: pagination.page,
          pageSize: pagination.pageSize,
        },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTAditamentoApprove = async (
  dispatch: Dispatch,
  aditamentoId: string,
  justification: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.put<string>(`${requestConfig.api}api/v1/aditamentos/${aditamentoId}/approve`, {
        justificativa: justification,
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTAditamentoDisapprove = async (
  dispatch: Dispatch,
  aditamentoId: string,
  justification: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.put<string>(`${requestConfig.api}api/v1/aditamentos/${aditamentoId}/disapprove`, {
        justificativa: justification,
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETAditamentoDocument = async (
  dispatch: Dispatch,
  aditamentoDocumentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<string>(`${requestConfig.api}api/v1/aditamentos/document/download`, {
        params: { aditamentoDocumentId: aditamentoDocumentId },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETGUIDInstrumentoFinanceiro = async (
  dispatch: Dispatch,
  instrumentoFinanceiroId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<string>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/guid-type-by-instrumento-financeiro-id`,
        {
          params: { instrumentoFinanceiroId: instrumentoFinanceiroId },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};
